const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_legal.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_legal")({
  beforeLoad: ({
    context: {
      viewer
    }
  }) => ({
    user: viewer.user
  }),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});